import { render, staticRenderFns } from "./TestedVersions.vue?vue&type=template&id=bd2bb3ee&scoped=true&"
import script from "./TestedVersions.vue?vue&type=script&lang=js&"
export * from "./TestedVersions.vue?vue&type=script&lang=js&"
import style0 from "./TestedVersions.vue?vue&type=style&index=0&id=bd2bb3ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2bb3ee",
  null
  
)

export default component.exports